import React from 'react';
import { Link } from 'react-router-dom';
import CalculatorSection from '@/components/sections/CalculatorSection';

export default function Calculator() {
  return (
    <div data-testid="calculator-page">
      <section className="pt-20 pb-16 border-b border-[#1a1a1a] hero-grid diag-lines inner-hero">
        <div className="container-r360">
          <div className="highlights-kicker text-blue">
            <span />
           Calculate your expected Revenue
          </div>
          <h1 className="font-display font-bold leading-[0.92] tracking-[-0.035em] text-[70px] sm:text-[4rem] md:text-[5.5rem] lg:text-[6.5rem]">
            PROJECT YOUR<br /><span className="accent">RECOVERABLE</span> REVENUE.
          </h1>
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mt-8 items-start">
            <p className="lg:col-span-7 text-[17px] text-[#c9c9c9] font-bold leading-relaxed">
              Four inputs. One number that matters. Our calculator projects how much monthly revenue you’re leaving on the table
              by paying for impressions instead of sales — and what Retarget360’s CPS model would recover for you.
            </p>
            <div className="lg:col-span-5 grid grid-cols-3 gap-4 border-t border-l border-[#1a1a1a] bg-white/5">
              {[
                { k: '2.8%', v: 'INDUSTRY CPS' },
                { k: '22×', v: 'AVG ROAS' },
                { k: '$0', v: 'CPM WASTE' },
              ].map((x, i) => (
                <div key={i} className="border-r border-b border-[#1a1a1a] p-5">
                  <div className="font-display text-[36px] font-black leading-none">{x.k}</div>
                  <div className="mono-label mt-2 text-[10px]">{x.v}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
       <section className="highlights-section">
        <div className="container-r360">
          <div className="highlights-kicker">
          <span />HOW THE MODEL WORKS
        </div>
          <h2 className="reveal-on-scroll lg:col-span-7 font-display text-[3.75rem] sm:text-[4.5rem] lg:text-[5.75rem] font-bold leading-[0.92] tracking-[-0.03em] text-[#262626] mb-12">
           <span className='accent'>Transparent</span>  Assumptions.
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-3 border-t border-l border-[#1a1a1a]">
            {[
              { k: '01', t: 'Visitor intent rate', b: 'We assume 2% of first-visit traffic and 15% of abandoning visitors carry genuine purchase intent.' },
              { k: '02', t: 'CPS recovery', b: 'Of those intent-weighted visitors, R360 recovers an industry-average 2.8% as verified sales.' },
              { k: '03', t: 'Take rate', b: 'Your invoice = 12% of recovered revenue. Negotiable. No minimums. Paid only on verified sales.' },
            ].map((s) => (
              <div key={s.k} className="border-r border-b border-[#1a1a1a] p-5 bg-white/70">
                <div className="text-[1.5rem] font-bold font-mono text-[#ff5117] mb-4">{s.k}</div>
                <div className="font-display font-bold text-[20px] lg:text-[24px] leading-tight mb-3">{s.t}</div>
                <p className="sec-subhead">{s.b}</p>
              </div>
            ))}
          </div>
          <div className="mt-12 flex flex-wrap gap-4">
            <Link to="/book-a-demo" className="btn btn-primary">Get a custom audit →</Link>
            <Link to="/pricing" className="btn btn-outline-alt">See pricing model</Link>
          </div>
        </div>
      </section>

      <CalculatorSection />

    </div>
  );
}
